import {useParams} from 'react-router-dom';
import {HealthProfileForm} from '../../../../../../../components/health-profile-form/health-profile-form';

export default function SeniorHealthSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id?: string} = useParams();

  return <HealthProfileForm userId={id || ''} canWrite />;
}
